import React, { useState, useEffect } from 'react';
import styles from './MarketMaps.module.scss';
import * as API from '@/services/api/product.service';
import generalStyles from '@/components/General/Styles.module.scss';
import API_STATES from '@/constants/StateConstants';
import { handleApiError } from '@/components/General/HandleApiError';
import FileInfoTableInstance from './FileInfoTableInstance';
import { Button } from 'antd';
import { marketMapUploadLimit } from '@/config';

const MAX_FILE_LIMIT = !isNaN(marketMapUploadLimit) ? marketMapUploadLimit : 10;
function FileInfoTable(props) {
    const [addFileApiStatus, setAddFileApiStatus] = useState(API_STATES.none);
    const [addFileApiError, setAddFileApiError] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isFileLimitReached, setIsFileLimitReached] = useState(false);

    const files = props.files;
    const folder = props.folder;
    const marketMapType = props.marketMapType;

    async function addFileData() {
        setAddFileApiStatus(API_STATES.loading);
        const result = await API.addMarketMapsFile(
            folder.name,
            marketMapType,
            folder.id,
            selectedFiles,
            (value)=> setUploadProgress(value),
        );
        switch (result.status) {
            case API_STATES.success:
                setAddFileApiStatus(API_STATES.success);
                setSelectedFiles([]);
                setAddFileApiStatus(API_STATES.none);
                setTimeout(() => {
                    setUploadProgress(0);
                    setAddFileApiStatus(API_STATES.none);
                    props.onFileUpdate()
                }, 2000);
                break;
            case API_STATES.error:
                let error = result.error;
                handleApiError(error, setAddFileApiStatus, setAddFileApiError);
                break;
            default:
                setAddFileApiError('');
                setAddFileApiStatus(API_STATES.none);
        }
    }

    function sanitizeFiles(files) {
        const remainingFilesLimit = MAX_FILE_LIMIT - selectedFiles.length;

        if (!files || files.length === 0) {
            return [];
        }

        if (remainingFilesLimit <= 0 || files.length > remainingFilesLimit) {
            setIsFileLimitReached(true);
            console.warm(`Maximum file limit of ${MAX_FILE_LIMIT} reached. Cannot add more files.`);
            return [];
        }

        const uniqueFiles = Array.from(files).filter(
            (file) => !selectedFiles.some((selected) => selected.name === file.name && selected.size === file.size)
        );

        const sanitizedFiles = Array.from(uniqueFiles).slice(0, remainingFilesLimit);

        return sanitizedFiles;
    }

    const handleFileChange = (e) => {
        try {
            setIsFileLimitReached(false);
            const files = sanitizeFiles(e.target.files);

            setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
        } catch (error) {
            console.error('error selecting files: ', error);
        }
    };

    const clearSelectedFiles = () => {
        setSelectedFiles([]);
    }
    return (
        <>
            <table className={styles.bundleTable}>
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>File Name</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {files.map((file) => {
                        return (
                            <FileInfoTableInstance
                                fileId={file.id}
                                fileName={file.name}
                                key={file.id}
                                folder={folder}
                                onFileUpdate={() => props.onFileUpdate()}
                            />
                        );
                    })}
                </tbody>
            </table>
            <div className={generalStyles['input-wrapper'] + ' ' + styles.dialogInputWrapper}>
                <div className={styles.fileInputWrapper}>
                    <span className={styles.fileLabel}>Select files</span>
                    <input
                        type="file"
                        className={styles.fileInput}
                        id="file-input"
                        onChange={handleFileChange}
                        multiple
                    />
                </div>

                {selectedFiles.length ? <span>{selectedFiles.length} File(s) added!</span> : null}

                <div className={styles.fileActionButtons}>
                    <Button disabled={selectedFiles.length ? false : true} onClick={clearSelectedFiles}>
                        Clear
                    </Button>
                    <Button disabled={selectedFiles.length === 0} onClick={addFileData}>
                        Upload
                    </Button>
                </div>
                <label data-test="add-file-status">
                    {addFileApiStatus === API_STATES.loading ? (
                        <span className={generalStyles.statusMessage}>Uploading...   ({uploadProgress}%)</span>
                    ) : addFileApiStatus === API_STATES.error ? (
                        <span className={generalStyles.errorMessage}>Error: {addFileApiError}</span>
                    ) : (
                        addFileApiStatus === API_STATES.success && (
                            <span className={generalStyles.successMessage}>Successfully Uploaded!</span>
                        )
                    )}
                </label>
            </div>
            {isFileLimitReached && (
                <div className={generalStyles.errorMessage}>You can only add a maximum of {MAX_FILE_LIMIT} files.</div>
            )}
            <div className={styles.fileSelectionNote}>Note: You can select a maximum of {MAX_FILE_LIMIT} files.</div>
        </>
    );
}

export default FileInfoTable;
